<template>
    <v-data-table
        :headers="headers"
        :items="historyItems"
        :loading="loadingHistory"
    >
        <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>{{ historyTab + " History" }}</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
            </v-toolbar>
        </template>
    </v-data-table>
</template>

<script>
    import {mapState, mapActions, mapMutations} from "vuex"

    export default {
        data () {
            return {
                headers: [],
                historyItems: [],
            }
        },

        created () {
            this.setHeaders()
        },

        computed: {
            ...mapState({
                selectedUserPayrollReport: state => state.payrollReportsHistories.selectedUserPayrollReport,
                historyTab: state => state.payrollReportsHistories.historyTab,
                loadingHistory: state => state.payrollReportsHistories.loadingHistory
            })
        },

        methods: {
            ...mapMutations({
                setLoadingHistory: "payrollReportsHistories/setLoadingHistory"
            }),

            ...mapActions({
                getUserSalaryRaiseHistory: "payrollReportsHistories/getUserSalaryRaiseHistory",
                getStaffBonusHistory: "payrollReportsHistories/getStaffUserBonusHistory",
                getStafHealthCareHistory: "payrollReportsHistories/getStaffUserHealthCareHistory",
                getStafIncentiveHistory: "payrollReportsHistories/getStaffUserIncentiveHistory",
                getStaffReimbursementHistory: "payrollReportsHistories/getStaffUserReimbursements",

                getStaffGarnishmentHistory: "payrollReportsHistories/getStaffUserGarnishments"
            }),

            async setHeaders () {
                this.setLoadingHistory(true)
                this.headers = [];
                this.historyItems = [];

                switch (this.historyTab) {
                    case "Raise": {
                        this.headers = [
                            {text: "Rate", value: "Rate", sortable: false},
                            {text: "Raise ($)", value: "Raise"},
                            {text: "Raise Date", value: "RaiseDate"},
                        ]

                        this.historyItems = await this.getUserSalaryRaiseHistory(this.selectedUserPayrollReport)

                        break;
                    }
                    case "Bonus": {
                        this.headers = [
                            {text: "Rate", value: "Rate", sortable: false},
                            {text: "Bonus ($)", value: "Bonus"},
                            {text: "Date", value: "Date"},
                        ]

                        this.historyItems = await this.getStaffBonusHistory(this.selectedUserPayrollReport)

                        break;
                    }
                    case "Reimbursements": {
                        this.headers = [
                            {
                                text: 'Date',
                                align: 'start',
                                sortable: false,
                                value: 'Date',
                            },
                            { text: "Amount ($)", value: "Amount" },
                            { text: "Type", value: "Type" },
                            { text: "Category", value: "Category" },
                            // { text: "Balance", value: "Balance" },
                            { text: "Entered By", value: "EnteredBy" },
                            { text: "Status", value: "Status" },
                        ]
                        this.historyItems = await this.getStaffReimbursementHistory(this.selectedUserPayrollReport)

                        break;
                    }
                    case "Health Care": {
                        this.headers = [
                            { text: "Type of Health Care", value: "TypeOfHealthCare" },
                            { text: "Date", value: "Date" },
                            { text: "Amount ($)", value: "Amount" },
                        ]
                        this.historyItems = await this.getStafHealthCareHistory(this.selectedUserPayrollReport);

                        break;
                    }
                    case "Incentives": {
                        this.headers = [
                            { text: "Type of Incentive", value: "TypeOfIncentive" },
                            { text: "Date", value: "Date" },
                            { text: "Amount ($)", value: "Amount" },
                        ]
                        this.historyItems = await this.getStafIncentiveHistory(this.selectedUserPayrollReport);

                        break;
                    }
                    case "Garnishments": {
                        this.headers = [
                            {
                                text: "Court Date",
                                align: "start",
                                sortable: true,
                                value: "CourtDate",
                            },
                            { text: "Agency", value: "Agency" },
                            { text: "Type", value: "Type" },
                            { text: "Account", value: "Account" },
                            { text: "Amount ($)", value: "Amount" },
                        ]
                        this.historyItems = await this.getStaffGarnishmentHistory(this.selectedUserPayrollReport)

                        break;
                    }
                }
            },
        },
    }
</script>